module.exports = __webpack_public_path__ + "static/img/图片 84.debf4ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/图片 84.png
// module id = +wEZ
// module chunks = 1